import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash/get';
import isString from 'lodash/isString';
import React from 'react';

import { ImageCaption } from '@/components/ImageCaption';

export const LifestyleGallery: React.FC<
  Queries.VariantPageQuery['variant']['lifestyleImages']
> = ({ images }): JSX.Element => {
  return (
    <section
      className="mx-4 mb-16 md:mx-8"
      style={
        {
          '--images': images.length,
        } as React.CSSProperties
      }
    >
      <h3 className="text-black mb-4 text-xl">Featured images</h3>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-[repeat(var(--images),minmax(0,1fr))] md:gap-4">
        {React.Children.toArray(
          images
            .filter(
              (image) =>
                !!image.gatsbyImageData ||
                (image?.file?.contentType || '').includes('video'),
            )
            .map((image) => {
              const hasCaption = get(image, 'metadata.tags', []).some(
                (tag) =>
                  tag.contentful_id === 'hasCaption' ||
                  tag.contentful_id === 'needsCredit',
              );

              const isVideo = (image?.file?.contentType || '').includes(
                'video',
              );

              return (
                <figure>
                  {isVideo ? (
                    <video
                      className="aspect-video h-full w-full overflow-hidden rounded-sm bg-gray-100 object-cover md:aspect-[3/2]"
                      autoPlay
                      muted
                      loop
                      src={image.file.url}
                    />
                  ) : (
                    <GatsbyImage
                      className="aspect-[3/2] overflow-hidden rounded-sm object-cover"
                      image={image.gatsbyImageData}
                      alt={image.description}
                    />
                  )}
                  {hasCaption && isString(image.description) ? (
                    <ImageCaption caption={image.description} />
                  ) : null}
                </figure>
              );
            }),
        )}
      </div>
    </section>
  );
};
